
import config from '../config'

export default function avatarUrl(fileName) {
  let baseUrl = config.baseUrl
  return baseUrl + "getavatar?avatar=" + fileName
}